(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure__list-wrapper'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-search"]) return;
  try {
    
const initTabs = function () {
  const tabs = document.querySelectorAll('[data-tabs]');
  const activeState = 'is-active';
  const parentLinkTagName = 'LI';
  const tabPrefix = 'tab--';

  if (tabs.length === 0)  return null;

  tabs.forEach(function (elTabs) {
    const tabLinksAll = elTabs.querySelectorAll('[data-tabs-link]');
    const tabsAll = elTabs.querySelectorAll('[data-tabs-tab]');

    Array.from(tabLinksAll).map(function (tabLink) {
      tabLink.addEventListener('click', function (event) {
        event.preventDefault();

        const tabIdHref = tabLink.getAttribute('href');
        const tabId = tabIdHref.substring(1);
        const tab = document.getElementById(tabId);
        const tabsSettings = elTabs.getAttribute('data-tabs');

        window.location.hash = tabPrefix + tabId;

        Array.from(tabLinksAll).map(function (el) {
          changeActiveState(el);
        });

        Array.from(tabsAll).map(function (el) {
          el.classList.remove(activeState);
        });

        changeActiveState(tabLink, true);
        tab.classList.add(activeState);

        if (tabsSettings === 'scrollable') {
          scrollToTab(tabLink, tab, false);
        } else if (tabsSettings === 'scrollable ignore-tab-link-height') {
          scrollToTab(tabLink, tab, true);
        }
      });
    });
  });
  setActiveTabFromUrl();

  function setActiveTabFromUrl() {
    const locationHash = window.location.hash;
    const realTabHref = locationHash.replace(tabPrefix,'');
    const targetTab = document.querySelector('[data-tabs-link][href="'+realTabHref+'"]');

    if (targetTab) {
        targetTab.dispatchEvent(new Event('click'));
    }
  }

  function scrollToTab(tabLink, tab, isIgnoreTabLinkHeight) {
    let tabLinkHeight = tabLink.offsetHeight;
    const tabPosition = tab.offsetTop;

    if (isIgnoreTabLinkHeight) {
      tabLinkHeight = 0;
    }
    window.scrollTo({ top: tabPosition - tabLinkHeight, behavior: 'smooth' });
  }

  function changeActiveState(tabLink, isAdd) {
    switch (isAdd) {
      case true:
        if (tabLink.parentElement.tagName === parentLinkTagName) {
          tabLink.parentElement.classList.add(activeState);
        } else {
          tabLink.classList.add(activeState);
        }
      break;
      default:
          if (tabLink.parentElement.tagName === parentLinkTagName) {
            tabLink.parentElement.classList.remove(activeState);
          } else {
            tabLink.classList.remove(activeState);
          }
      break;
    }
  }
}
window.addEventListener('DOMContentLoaded', function() {
    initTabs();
});

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    if (document.querySelector('#recommended ul').innerHTML.trim() === '' && typeof this.dataset.url !== 'undefined') {
      this.init();
    }
  }

  init() {
  fetch(this.dataset.url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('product-recommendations');

      if (recommendations && recommendations.innerHTML.trim().length) {
        this.innerHTML = recommendations.innerHTML;
      }
      if (html.querySelector('.grid__item')) {
        this.classList.add('product-recommendations--loaded');
      }
      if (this.querySelector('.tabs__nav')) {
        initTabs();
      }
      this.allowRequest = false;
    })
    .catch(e => {
      this.allowRequest = false;
      console.error(e);
    });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
const initTabs = function () {
  const tabs = document.querySelectorAll('[data-tabs]');
  const activeState = 'is-active';
  const parentLinkTagName = 'LI';
  const tabPrefix = 'tab--';

  if (tabs.length === 0)  return null;

  tabs.forEach(function (elTabs) {
    const tabLinksAll = elTabs.querySelectorAll('[data-tabs-link]');
    const tabsAll = elTabs.querySelectorAll('[data-tabs-tab]');

    Array.from(tabLinksAll).map(function (tabLink) {
      tabLink.addEventListener('click', function (event) {
        event.preventDefault();

        const tabIdHref = tabLink.getAttribute('href');
        const tabId = tabIdHref.substring(1);
        const tab = document.getElementById(tabId);
        const tabsSettings = elTabs.getAttribute('data-tabs');

        window.location.hash = tabPrefix + tabId;

        Array.from(tabLinksAll).map(function (el) {
          changeActiveState(el);
        });

        Array.from(tabsAll).map(function (el) {
          el.classList.remove(activeState);
        });

        changeActiveState(tabLink, true);
        tab.classList.add(activeState);

        if (tabsSettings === 'scrollable') {
          scrollToTab(tabLink, tab, false);
        } else if (tabsSettings === 'scrollable ignore-tab-link-height') {
          scrollToTab(tabLink, tab, true);
        }
      });
    });
  });
  setActiveTabFromUrl();

  function setActiveTabFromUrl() {
    const locationHash = window.location.hash;
    const realTabHref = locationHash.replace(tabPrefix,'');
    const targetTab = document.querySelector('[data-tabs-link][href="'+realTabHref+'"]');

    if (targetTab) {
        targetTab.dispatchEvent(new Event('click'));
    }
  }

  function scrollToTab(tabLink, tab, isIgnoreTabLinkHeight) {
    let tabLinkHeight = tabLink.offsetHeight;
    const tabPosition = tab.offsetTop;

    if (isIgnoreTabLinkHeight) {
      tabLinkHeight = 0;
    }
    window.scrollTo({ top: tabPosition - tabLinkHeight, behavior: 'smooth' });
  }

  function changeActiveState(tabLink, isAdd) {
    switch (isAdd) {
      case true:
        if (tabLink.parentElement.tagName === parentLinkTagName) {
          tabLink.parentElement.classList.add(activeState);
        } else {
          tabLink.classList.add(activeState);
        }
      break;
      default:
          if (tabLink.parentElement.tagName === parentLinkTagName) {
            tabLink.parentElement.classList.remove(activeState);
          } else {
            tabLink.classList.remove(activeState);
          }
      break;
    }
  }
}
window.addEventListener('DOMContentLoaded', function() {
    initTabs();
});

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    if (document.querySelector('#recommended ul').innerHTML.trim() === '' && typeof this.dataset.url !== 'undefined') {
      this.init();
    }
  }

  init() {
  fetch(this.dataset.url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('product-recommendations');

      if (recommendations && recommendations.innerHTML.trim().length) {
        this.innerHTML = recommendations.innerHTML;
      }
      if (html.querySelector('.grid__item')) {
        this.classList.add('product-recommendations--loaded');
      }
      if (this.querySelector('.tabs__nav')) {
        initTabs();
      }
      this.allowRequest = false;
    })
    .catch(e => {
      this.allowRequest = false;
      console.error(e);
    });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
